import * as React from 'react';

const SvgDocBot = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 22 22"
    {...props}
  >
    <g clipPath="url(#clip0_455_232228)" transform="translate(-13 -13)">
      <path
        fill="url(#paint0_linear_455_232228)"
        d="M31 21l1.25-2.75L35 17l-2.75-1.25L31 13l-1.25 2.75L27 17l2.75 1.25zm-7.5.5L21 16l-2.5 5.5L13 24l5.5 2.5L21 32l2.5-5.5L29 24zM31 27l-1.25 2.75L27 31l2.75 1.25L31 35l1.25-2.75L35 31l-2.75-1.25z"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_455_232228"
        x1="17.5"
        x2="40"
        y1="13"
        y2="13"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stopColor="#6268FF"
          offset="0.255"
        />
        <stop
          stopColor="#3BA7FF"
          offset="1"
        />
      </linearGradient>
      <clipPath id="clip0_455_232228">
        <path fill="#fff" d="M0 0H24V24H0z" transform="translate(12 12)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgDocBot;
